import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { Vendor } from '../../models/domain/vendor';

import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../services/ss-api.service';
import { EditVendorRequest } from '../../models/ss-api/requests/edit.vendor.request';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';


export interface IVendorEditMemberDialogModel {
    title: string;
    subTitle: string;
    message: string;
    Vendor: Vendor
}


@Component({
    selector: 'stats-vendor-edit-member-dialog',
    styleUrls: ['./stats.vendor.edit.dialog.css'],
    templateUrl: './stats.vendor.edit.dialog.html'
})
export class StatsVendorEditDialog extends DialogComponent<IVendorEditMemberDialogModel, boolean> implements IVendorEditMemberDialogModel, OnInit {
    IsBusy: boolean = false;

    title: string;
    subTitle: string;
    message: string;

    Form: FormGroup;

    Vendor: Vendor;
    newVendor: Vendor = new Vendor;

    constructor(dialogService: DialogService,
        private sweetAlertService: SweetAlertService,
        private api: ssApiService,
        public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.setUpNewVendor();
        this.setUpForm();
    }

    setUpNewVendor() {
        this.newVendor.DateTimeCreated = this.Vendor.DateTimeCreated;
        this.newVendor.DisplayName = this.Vendor.DisplayName;
        this.newVendor.Email = this.Vendor.Email;
        this.newVendor.FirstName = this.Vendor.FirstName;
        this.newVendor.LastName = this.Vendor.LastName;
        this.newVendor.ID = this.Vendor.ID;
        this.newVendor.IsActive = this.Vendor.IsActive;
        this.newVendor.Items = this.Vendor.Items;
    }

    setUpForm() {
        this.Form = new FormGroup({
            'DisplayName': new FormControl('', [Validators.required]),
            'FirstName': new FormControl('', [Validators.required]),
            'LastName': new FormControl('', [Validators.required]),
            'Email': new FormControl('', [Validators.required, Validators.email]),
            'IsActive': new FormControl(''),
        });
    }

    confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code

        let request: EditVendorRequest = new EditVendorRequest;
        request.DisplayName = this.newVendor.DisplayName;
        request.FirstName = this.newVendor.FirstName;
        request.LastName = this.newVendor.LastName;
        request.Email = this.newVendor.Email;
        request.ID = this.newVendor.ID;
        request.IsActive = this.newVendor.IsActive;

        this.sweetAlertService.swal({
            title: 'Update Vendor?',
            text: 'Are you sure you want to change this vendor record?',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                // addcard
                return this.api.EditVendor(request).toPromise();
            }
        })
            .then(
                async (response) => {

                    if (!response.Result) {
                        this.sweetAlertService.swal(
                            {
                                title: 'Error',
                                text: 'Error Editing Vendor',
                                type: 'error',
                                showCancelButton: false,
                                showConfirmButton: false,
                                timer: 1500
                            })
                            .then(() => { }, () => { }); // keep this line to prevent promise error;
                        return;
                    }


                    // show confirmation
                    this.sweetAlertService.swal(
                        {
                            title: 'Success',
                            text: 'Vendor was succesfully added',
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500
                        })
                        .then(() => {

                        }, () => { }); // keep this line to prevent promise error;

                    this.close();
                },
                (dismiss) => {
                    if (dismiss === 'cancel') {

                        if (!confirm)
                            return;

                        // show cancelled
                        this.sweetAlertService.swal({
                            title: 'Cancelled',
                            text: 'No changes are saved.',
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1000
                        }).then(() => {
                            this.close();
                        }, () => { }); // keep this line to prevent promise error;
                    }
                }).catch(error => {
                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: error.message,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                        })
                        .then((response: any) => {
                            this.result = false;
                            // this.IsBusy = false;
                            this.close();
                        }, (dismiss) => {
                            // this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                });

    }


}
